export const GHG_QUALITY_OPTIONS = ["H", "M", "L"];
const QUALITY_RANK = { L: 0, M: 1, H: 2 };
export const isGhgQuality = (value) => value === "H" || value === "M" || value === "L";
export const toGhgQuality = (value) => (isGhgQuality(value) ? value : null);
const worseOfTwo = (a, b) => (QUALITY_RANK[a] <= QUALITY_RANK[b] ? a : b);
export function worseQuality(a, b) {
    const left = isGhgQuality(a) ? a : null;
    const right = isGhgQuality(b) ? b : null;
    if (left === null)
        return right;
    if (right === null)
        return left;
    return worseOfTwo(left, right);
}
export function combineEmissionQuality(...componentList) {
    if (componentList.length === 0)
        return "L";
    const validatedList = [];
    for (const component of componentList) {
        if (!isGhgQuality(component))
            return "L";
        validatedList.push(component);
    }
    return validatedList.reduce((worst, component) => worseOfTwo(worst, component), "H");
}
